const globalConversationsActions = {
    SET_SOCKET: 'SET_SOCKET',
};

export default globalConversationsActions;
